// @flow
import React from 'react';
import ClinicianAvailabilityContainer from '../../../../ClinitianAvailability/Matching/ClinicianAvailabilityContainer';


export default function ClinicianAvailabilityQuestion({
    choices,
    userId,
    handleOnclick,
    setIsMatchAssistance,
}: any): React$Element<any> {
    return (
        <ClinicianAvailabilityContainer
            choices={choices}
            selectedUserId={userId}
            isFromQuestionnaire={true}
            handleOnclick={handleOnclick}
            setIsMatchAssistance={setIsMatchAssistance}
        />
    );
}
